let preloadPromise: Promise<string> | null = null;

export function splinePreload(url: string): Promise<string> {
  if (typeof window === 'undefined') {
    return Promise.resolve(url);
  }

  if (!preloadPromise) {
    preloadPromise = fetch(url, {
      cache: 'force-cache',
      priority: 'high'
    })
      .then((res) => {
        if (!res.ok) throw new Error('Spline asset preload failed');
        return res.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        return `${blobUrl}#.splinecode`;
      })
      .catch((err) => {
        console.error(err);
        return url;
      });
  }

  return preloadPromise;
}

export function getSplinePreloadPromise() {
  return preloadPromise;
}